import { Login, Logout, GetCountryList } from "@a/account";
import { setAccessToken, setRefreshToken, getAccessToken, getRefreshToken, removeAccessToken, removeRefreshToken } from '@u/cookies';
import i18n from '@/i18n/i18n';
const state = {
    collapse: JSON.parse(sessionStorage.getItem('collapse')) || false,
    accessToken: '' || getAccessToken(),
    refreshToken: '' || getRefreshToken(),
    accountInfo: JSON.parse(sessionStorage.getItem('accountInfo')) || {},
    currentMenu: JSON.parse(sessionStorage.getItem('currentMenu')) || {},
    curentMedia: sessionStorage.getItem('curentMedia') || 0, //0:web 1:mobile
    countries: JSON.parse(sessionStorage.getItem('countries')) || [],
    lang: sessionStorage.getItem('lang') || 'en'
}
const getters = {

}
const mutations = {
    SET_COLLAPSE(state, value) {
        if (typeof (value) === 'boolean') {
            state.collapse = value;
        } else {
            state.collapse = !state.collapse;
        }
        sessionStorage.setItem('collapse', JSON.stringify(state.collapse));
    },
    SET_ACCESSTOKEN(state, value) {
        state.token = value;
        value && setAccessToken(value);
    },
    SET_REFRESHTOKEN(state, value) {
        state.username = value;
        value && setRefreshToken(value);
    },
    SET_ACCOUNTINFO(state, value) {
        state.accountInfo = value;
        sessionStorage.setItem('accountInfo', JSON.stringify(value));
    },
    SET_CURRENTMENU(state, value) {
        state.currentMenu = value;
        sessionStorage.setItem('currentMenu', JSON.stringify(value));
    },
    SET_CURRENTMEDIA(state, value) {
        state.curentMedia = value;
        sessionStorage.setItem('curentMedia', value);
    },
    SET_COUNTRIES(state, value) {
        state.countries = value;
        sessionStorage.setItem('countries', JSON.stringify(value));
    },
    SET_LANG(state, value) {
        state.lang = value;
        sessionStorage.setItem('lang', value);
    }
}
const actions = {
    loginAction(context, requestData) {
        return new Promise((resolve, reject) => {
            Login(requestData).then(res => {
                let data = res.data;
                context.commit('SET_ACCESSTOKEN', data.accessToken);
                context.commit('SET_REFRESHTOKEN', data.refreshToken);
                context.commit('SET_ACCOUNTINFO', data);
                // context.dispatch('changeLang');
                resolve(res.data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    logoutAction({ commit }) {
        return new Promise((resolve, reject) => {
            Logout().then(res => {
                removeAccessToken();
                removeRefreshToken();
                commit('SET_ACCESSTOKEN', '');
                commit('SET_REFRESHTOKEN', '');
                resolve(res);
            }).catch(error => {
                reject(error)
            })
        })
    },
    getCountries(context) {
        if (sessionStorage.getItem('countries')) {
            return context.state.countries;
        } else {
            GetCountryList().then(res => {
                context.commit('SET_COUNTRIES', res.data);
            })
        }
    },
    changeLang(context) {
        let countryId = context.state.accountInfo.countryId;
        let lang = 'en';
        if (countryId == 9 || countryId == 21) {
            lang = 'zh-CN';
        } else if (countryId == 18) {
            lang = 'cs';
        } else if (countryId == 39) {
            lang = 'es';
        } else if (countryId == 35) {
            lang = 'pt';
        } else {
            lang = 'en';
        }
        context.commit('SET_LANG', lang);
        i18n.locale = lang;
    }
}
export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/app.js